import React, { useMemo } from 'react';
import { Trans } from 'react-i18next';
import { PapiDeviation } from '@wix/da-papi-types';
import { getReadingTimeMinutes } from '../../Thumb/helpers';

export interface Props {
  deviation: PapiDeviation;
}

const ReadingTime: React.FC<Props> = ({ deviation }) => {
  const readingTime = useMemo(
    () => getReadingTimeMinutes(deviation.textContent),
    [deviation.textContent]
  );

  /* prettier-ignore */
  return(
    <Trans i18nKey="deviationview.journal.readingTime" count={readingTime}>
      {{ readingTime }} min
    </Trans>
  );
};
ReadingTime.displayName = 'ReadingTime';

export default ReadingTime;
